export const initialiseFilterAdvancedLocation = (widget: HTMLElement) => {
    const filter = widget.querySelector<HTMLDivElement>('.location-filter')
    if (!filter) return

    const header = filter.querySelector<HTMLHeadingElement>('.header')
    if (!header) return

    const button: HTMLButtonElement = document.createElement('button')
    button.className = header.className
    button.innerHTML = header.innerHTML

    header.replaceWith(button)
    
    const clearSearchInput = filter.querySelector<HTMLInputElement>('.clear-search')
    if (!clearSearchInput) return
    
    const clearSearchButton = document.createElement('button')
    clearSearchButton.id = clearSearchInput.id
    clearSearchButton.className = clearSearchInput.className
    clearSearchButton.type = 'button'
    clearSearchButton.ariaLabel = '{{js.page.jobs.filters.button.clear-search.aria-label}}'

    clearSearchInput.replaceWith(clearSearchButton)

    const slider = filter.querySelector<HTMLDivElement>('.location-slider');
    slider?.setAttribute('role', 'slider')
    slider?.setAttribute('aria-label', 'job location')

    const input = filter.querySelector<HTMLInputElement>('.location-search-input')
    const radius = filter.querySelector<HTMLInputElement>('.location-radius-value')
    if (input) {
        input.setAttribute('aria-label', '{{js.page.jobs.filters.location.aria-label}}')
    }
    if (radius) {
        radius.setAttribute('aria-label', '{{js.page.jobs.filters.location.radius.aria-label}}')
    }
}
